export const mcpData = {
  hero: {
    tag: {
      text: "Cobalt MCP",
      href: "/cobalt-mcp",
    },
    cta: {
      primary: {
        text: "Get Started",
        href: "/signup",
      },
      secondary: {
        text: "Book a demo",
        href: "/demo",
      },
    },
    title: "Introducing Cobalt MCP: The Layer Built for Enterprise Systems",
    description: "Cobalt's MCP connects <strong>SAP</strong>, <strong>Oracle Financials</strong>, <strong>Workday</strong>, and <strong>300+</strong> other enterprise systems orchestrating <strong>10,000+</strong> pre-built actions and complex <strong>AI-driven workflows</strong> on a secure, enterprise-grade platform."
  },
  videoContainer: {
    videoSrc: "https://www.loom.com/embed/4347b4e46edc43f0827c63476aaabd9f?hideEmbedTopBar=true",
    description: "Optional description text about the video",
    className: "optional-additional-classes"
  },
  enterpriseFeatures: {
    title: "Powering the Enterprise Future",
    subtitle: "Explore the breakthrough capabilities behind Cobalt MCP",
    features: [
      {
        icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/stash_integrations.svg",
        title: "300+ Integrations. 10,000+ Actions",
        description: "Tap into the largest AI-ready integration network for enterprise apps",
        bulletPoints: [
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/Vector.svg",
            text: "Connect seamlessly to SAP, Oracle, Workday and hundreds more"
          },
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/Vector+(1).svg",
            text: "Leverage 10,000+ prebuilt, AI-ready actions and workflows"
          },
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/Vector+(2).svg",
            text: "Extend your agent's capabilities without complex integration"
          }
        ]
      },
      {
        icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/fluent-mdl2_passive-authentication.svg",
        title: "Managed Authentication for Every App",
        description: "Securely connect your end-users to any external or internal system",
        bulletPoints: [
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/Vector+(3).svg",
            text: "Connect seamlessly to SAP, Oracle, Workday and hundreds more"
          },
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/Vector+(4).svg",
            text: "Leverage 10,000+ prebuilt, AI-ready actions and workflows"
          },
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/Vector+(5).svg",
            text: "Extend your agent's capabilities without complex integration"
          }
        ]
      },
      {
        icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/material-symbols_enterprise-outline.svg",
        title: "Automate Complex Enterprise Workflows",
        description: "Expose intelligent, multi-step workflows as a single MCP endpoint",
        bulletPoints: [
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/carbon_ibm-open-enterprise-languages.svg",
            text: "Connect seamlessly to SAP, Oracle, Workday and hundreds more"
          },
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/Vector+(6).svg",
            text: "Leverage 10,000+ prebuilt, AI-ready actions and workflows"
          },
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/hugeicons_ai-network.svg",
            text: "Extend your agent's capabilities without complex integration"
          }
        ]
      },
      {
        icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/hugeicons_ai-security-01.svg",
        title: "Enterprise-Grade Security & Control",
        description: "Built for scale, trust, and compliance",
        bulletPoints: [
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/Vector+(7).svg",
            text: "Connect seamlessly to SAP, Oracle, Workday and hundreds more"
          },
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/Vector+(8).svg",
            text: "Leverage 10,000+ prebuilt, AI-ready actions and workflows"
          },
          {
            icon: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Icons/mdi_security-lock-outline.svg",
            text: "Extend your agent's capabilities without complex integration"
          }
        ]
      }
    ]
  },
  bentoItems: [
    {
      title: "Create Your MCP Server",
      description:
        "Start by creating a Cobalt MCP server. Select the enterprise apps you want to connect -like SAP, Oracle, Workday, and 300+ others -and choose the specific API actions and workflows your AI agent should have access to.",
      imageSrc:
        "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Server+Creation.svg",
      imageAlt: "Go to market illustration",
    },
    {
      title: "Generate Your MCP URL",
      description:
        "Cobalt instantly generates a secure MCP URL that encapsulates all selected capabilities and context. This URL serves as the entry point for any AI agent to take meaningful action across your enterprise systems.",
      imageSrc:
        "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Url++Generation.svg",
      imageAlt: "Engineering illustration",
    },
    {
      title: "Plug It Into Your Agent",
      description:
        "Drop the MCP URL into platforms like Cursor, Anthropic, or Windsurf. With a single integration point, your AI agent is now enterprise-ready — able to trigger actions, run workflows, and interface with your most critical systems.",
      imageSrc:
        "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Plug+it+to+your+Agent.svg",
      imageAlt: "Market reach illustration",
    },
  ],
  enterpriseEcosystem: {
    title: "Enterprise Software Ecosystem",
    description: "Our AI agents seamlessly connect with your existing enterprise software stack, with more integrations being added regularly.",
    applications: [
      {
        logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Application+card.svg",
        name: "Sap"
      },
      {
        logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Application+card2.svg",
        name: "Salesforce"
      },
      {
        logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Application+card3.svg",
        name: "Oracle"
      },
      {
        logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Application+card4.svg",
        name: "Microsoft Dynamics"
      },
      {
        logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Application+card5.svg",
        name: "Workday"
      },
      {
        logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Application+card6.svg",
        name: "Jira"
      },
      {
        logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Application+card7.svg",
        name: "Zendesk"
      },
      {
        logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Application+card8.svg",
        name: "Quickbook"
      },
      {
        logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Application+card9.svg",
        name: "Netsuite"
      },
      {
        logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/MCP+Page+Images/Application+card10.svg",
        name: "Service Now"
      }
    ],
    extraText: "290+ more application"
  },
  cta: {
    title: "The future of software is seamlessly Integrated",
    description: "Be ready with Cobalt's embedded integration platform",
    cta: {
      text: "Get Started",
      href: "/signup",
      secondary: {
        text: "Book a Demo",
        href: "https://cal.com/cobalt/welcome-to-cobalt"
      }
    }
  }
};